// ---------------------------------------------------------------------------
// MCP DEMO CONTENT — mock / illustrative only.
//
// All copy for the B2C (shopper) and B2B (retailer) assistant demos lives here
// so it can be refined in ONE place. NONE of this calls a real LLM; the answers
// are pre-written placeholders streamed as mock chat bubbles. They are plausible
// and generic and must be framed in the UI as an illustrative demo — never as
// verified fit facts.
// ---------------------------------------------------------------------------

// Shared assistant button bar (both demos use the same set).
export const ASSISTANTS = [
  { key: "claude", label: "Claude" },
  { key: "chatgpt", label: "ChatGPT" },
  { key: "gemini", label: "Gemini" },
  { key: "other", label: "Other" },
];

// ---------------------------------------------------------------------------
// B2C — the SHOPPER's own assistant answers using their FitKey.
// ---------------------------------------------------------------------------
export const B2C_QUESTIONS = [
  {
    id: "adizero-socks",
    q: "Can I wear the Adidas Adizero Adios Pro 4 in my size with thick socks?",
    a: "Your FitKey says a 26.2 cm foot — EU 42 in most brands. The Adizero Adios Pro 4 is a race shoe with a snug, performance last and runs slightly small. With thick socks I'd size up to EU 42½ so your toes keep about 1 cm of room. If you race in thin socks, stay at 42. Want me to open it in your size on adidas.com?",
  },
  {
    id: "pegasus-tts",
    q: "Is the Nike Pegasus 41 true to size for me?",
    a: "Yes. For your FitKey (foot length 26.2 cm) the Pegasus 41 fits true to size at EU 42. The mesh upper has a little give, so no need to size up unless you like extra toe room or wear orthotics.",
  },
  {
    id: "nb-1080-width",
    q: "Which width should I pick in the New Balance 1080?",
    a: "New Balance offers the 1080 in B, D, 2E and 4E. Your FitKey doesn't include a measured foot width yet, so start with the standard D. If your current shoes feel tight across the ball, go 2E. Add a width scan to your FitKey and I'll pick it automatically next time.",
  },
];

// ---------------------------------------------------------------------------
// B2B — the RETAILER's assistant. It always asks to use the stored FitKey
// before answering, then gives a detailed, catalog-aware reply.
// ---------------------------------------------------------------------------
export const B2B_CONFIRM = {
  text: "I can check this against your saved Fittin FitKey. Use it to answer?",
  cta: "Use my FitKey",
};

export const B2B_QUESTIONS = [
  {
    id: "kayano-fit",
    context: "Asics Gel-Kayano product page",
    q: "Will these fit me?",
    a: "Using your FitKey (foot length 26.2 cm, standard width): the Gel-Kayano runs true to size, so EU 42 (UK 7½, US 8½) is your fit here. It's a stability shoe with a structured heel, so I wouldn't size down. Add to cart in EU 42?",
  },
  {
    id: "puma-cross-brand",
    context: "Puma product page",
    q: "I usually take a 43 in Nike — what's my size here?",
    a: "Your Nike 43 maps to a 26.7 cm foot on your FitKey. This Puma model fits true to size, which puts you at EU 43 as well (UK 9, US 10). No adjustment needed.",
  },
  {
    id: "wide-feet",
    context: "Product page",
    q: "Is this good for wide feet?",
    a: "Your FitKey is set to standard width. This model comes in a regular last only, so for wider feet it may feel snug across the forefoot — a half size up (EU 42½) buys a little room, or I can show wide-fit alternatives that offer a 2E width.",
  },
];
